<template>
  <b-modal
    ref="mc-modal"
    size="md"
    centered
    scrollable
    :title="$slots.title ? undefined : $t('global.action.changeStatus')"
  >
    <template v-if="$slots.title" #modal-title>
      <slot name="title" />
    </template>
    <McAlert
      v-if="alertTransition?.show"
      :variant="alertTransition.variant"
      :html="alertTransition.html"
      withIcon
      :withGap="false"
    />
    <div class="card-body p-2">
      <p v-if="!$slots.confirmationText">
        <span>{{ $t('global.text.modal.changeStatus') }} </span>
        <strong>{{ entityData?.number }}</strong>
        <span>?</span>
      </p>
      <div v-else>
        <slot name="confirmationText" />
      </div>

      <p v-if="!hideStatusPreview">
        <strong>{{ getStatusLabel(entityData.status) }}</strong>
        <i class="__transition-icon icon-fill_arrow-right"></i>
        <strong>{{ getStatusLabel(newStatusTransition?.status) }}</strong>
      </p>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0">
        <McButton
          variant="secondary"
          class="me-2"
          :text="textSecondaryBtn || $t('global.action.no')"
          @click="() => { cancel(); $emit('cancel') }"
        />
        <McButton
          variant="primary"
          :text="textPrimaryBtn || $t('global.action.yes')"
          @click="handleTransition"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import McAlert from '@/components/McAlert'

export default {
  components: {
    McButton,
    McAlert,
  },
  props: {
    entityData: {
      required: true,
    },
    newStatusTransition: {
      required: true,
    },
    hideStatusPreview: Boolean,
    textPrimaryBtn: {
      type: String,
    },
    textSecondaryBtn: {
      type: String,
    },
    alertTransition: {
      type: Object,
      default: () => ({}),
    },
    hasLimitBulkTransition: {
      type: Object,
      default: () => ({}),
    },
    getStatusLabelFn: {
      type: Function,
      default: null,
    },
  },
  emits: ['transition'],
  methods: {
    getStatusLabel(status) {
      if (!status) return '-'

      if (this.getStatusLabelFn) {
        return this.getStatusLabelFn(status)
      }

      return status.label ? this.$t(status.label) : status.name
    },
    handleTransition() {
      this.$emit('transition', {
        transition: this.newStatusTransition,
      })
    },
    show() {
      this.$refs['mc-modal'].show()
    },
    hide() {
      this.$refs['mc-modal'].hide()
    },
  },
}
</script>

<style lang="scss">
.__transition-icon {
  font-size: 20px;
  vertical-align: middle;
  margin: 0 10px;

  &::before {
    color: #4a90e1;
  }
}

p {
  color: $mep-color-text;
}

strong {
  font-weight: 600;
}
</style>
